<template>
  <div class="left">
    <div>
      <font-awesome-icon :icon="['far', 'clock']" size="6x" />
    </div>
    <div class="success text-title">
      {{ $vt('Your order is still processing, please contact the suport if you have any question.') }}
    </div>
    <div>
      <f-button type="tertiary" blank
        href="mailto:support@vodalys.com?subject=Order still processing"><font-awesome-icon
          :icon="['far', 'envelope']" /> support@vodalys.com</f-button>
    </div>
  </div>
</template>
<script>
export default {
  translate25Context: 'stripe',
  props: ["component", "handler"],
}
</script>